import { configureStore } from '@reduxjs/toolkit';
import reducer from './reducer';
import { ThunkAction } from 'redux-thunk';
import { useDispatch as _useDispatch } from 'react-redux';
import { GlobalAction } from '../global-types';
import { EventsAction } from '../pages/events/types';
import { ContactAction } from '../pages/contact/types';
import { PartsActions } from '../pages/parts/reducer';
import { FleetDetailAction } from '../pages/fleet/details/types';
import { FleetAction } from '../pages/fleet/home/types';
import { RegisterAction } from '../pages/register/reducer';

export const store = configureStore({
  reducer,
  // configureStore adds redux-thunk by default; adjust middleware if needed:
  // middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(/* extra middleware */),
  devTools: true
});

if ((module as any).hot) {
  (module as any).hot.accept('./reducer', () => {
    const nextRootReducer = require('./reducer').default;
    store.replaceReducer(nextRootReducer);
  });
}

export type RootState = ReturnType<typeof store.getState>;
type AllActions =
  | GlobalAction
  | EventsAction
  | ContactAction
  | PartsActions
  | FleetDetailAction
  | FleetAction
  | RegisterAction;

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  AllActions
>;

export type AppDispatch = typeof store.dispatch;

export function useDispatch(): AppDispatch {
  return _useDispatch<AppDispatch>();
}
